module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/068-djibouti-bd3380d62037460c4b20f9ad18b310a1.svg";